/* istanbul ignore file */
const A_LIST = 'A-LIST'; // legacy tier name
const LOYALLIST = 'LOYALLIST'; // legacy tier name
const THIRD_PARTY = 'THIRD-PARTY'; // legacy tier name
const BASE_3P = 'BASE-3P'; // new tier name for third party
const BASE_BCC = 'BASE-BCC'; // new tier name for loyallist
const TOL_PREFIX = 'TOL';
const UNL_PREFIX = 'UNL';

export default (tierName) => {
  if (tierName === A_LIST || tierName?.startsWith(TOL_PREFIX)) {
    return 'tol';
  }

  if (tierName?.startsWith(UNL_PREFIX)) {
    return 'unlocked';
  }

  if (tierName === THIRD_PARTY || tierName === BASE_3P || tierName === BASE_BCC || tierName === LOYALLIST) {
    return 'base';
  }

  return '';
};
